import React from "react";
import logo from '../../Images/assetLogoWithtext.png'

const Loading = () => {
  return (
    <div className="preloader">
      <div className="flash-screen">
        <div className="flash-body bg-primary">
          <img
            src={logo}
            alt="Logo"
            width="180px"
            style={{ marginRight: '0.5rem' }}
          />
          <div className="text-container">
            <h1 className="club-name text-primary fw-bold text-2xl">Inteli Asset</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loading;
